import { ACTION_LOGOUT_INITIATED, TILE_CHANGE } from '../actions/types';

const initialState = {
	tile: 'Home',
};

export default function (state = initialState, action) {
	switch (action.type) {
		case TILE_CHANGE:
			return {
				...state,
				tile: action.payload,
			};

		case ACTION_LOGOUT_INITIATED:
			return initialState;

		default:
			return state;
	}
}
